import 'leaflet'
import Vue from 'vue'

let emitter = Vue.prototype.$emitter

const BasePopup = L.Popup.extend({
  getVueComponent: function () {
    console.error('Please describe VueComponent')
    return null
  },

  /*
  work in leaflet 1.9.3
   */
  _initLayout: function () {
    let container = (this._container = L.DomUtil.create(
      'div',
      (this.options.className || 'tooltip tooltip--top') +
        ' leaflet-zoom-animated'
    ))

    let childDiv = document.createElement('div')
    container.appendChild(childDiv)

    let el = this.getVueComponent()
    this.options.closeCallback = ($event) => {
      this._close($event)
    }
    el.injectConf(this.options)
    el.$mount(childDiv)
    this.vueEl = el

    // if in context menu exist lastEventPos
    if (
      !this.options.autoPan &&
      this._source &&
      this._source.options &&
      this._source.options.lastEventPos
    ) {
      let latlng = this._source.options.lastEventPos
      // rewrite coords of popup
      this._latlng = latlng
      if (!this._source.options.lastEventNoPan) {
        // center map om coords
        let popupXY = this._map.latLngToLayerPoint(latlng)
        let height = this.options.height || 700
        // get y center
        const bottomOffset = this.options.bottomOffset || 50
        let yOffset = Math.round(height / 2) - bottomOffset
        let mapXY = this._map.layerPointToLatLng(
          L.point(popupXY.x, popupXY.y - yOffset)
        )
        emitter.emit('geo.mapSetView', Object.assign(mapXY, { delay: 350 }))
      }
    }

    this._contentNode = container

    L.DomEvent.disableClickPropagation(container)
    L.DomEvent.disableScrollPropagation(this._contentNode)
    L.DomEvent.on(container, 'contextmenu', L.DomEvent.stopPropagation)
  },

  /*
  work in leaflet 1.9.3
   */
  _close: function () {
    if (this._map) {
      this._map.closePopup(this)
      this.options.opts?.vm.registerClosePopup()
    }
  },
})

export default BasePopup
